import { Box, Typography } from '@mui/material';

import { CustomButton } from '../../../../common/components';

const PaymentOrderProviderHeader = ({ controller }) => {
  const {
    activeProvider,
    activeProviderIncludedInvoices,
    activeProviderOrderGroups,
    hasMultipleProviders,
    includedInvoices,
    markReadyAndMoveNext,
    setActiveSection,
  } = controller;

  if (!activeProvider) return null;
  const internalOrderCount = activeProviderOrderGroups.length;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) auto auto' },
        gap: 1.25,
        alignItems: 'center',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        backgroundColor: 'background.formTables',
        p: 1.25,
        mb: 1.5,
        minWidth: 0,
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="caption" sx={{ display: 'block', color: 'primary.main', fontWeight: 800, lineHeight: 1.2 }}>
          Proveedor en edición
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: 'text.primary',
            fontWeight: 800,
            lineHeight: 1.25,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={activeProvider.providerName}
        >
          {activeProvider.providerName}
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700 }}>
          {activeProviderIncludedInvoices.length}/{activeProvider.invoices.length} facturas incluidas
          {internalOrderCount > 1 ? ` - ${internalOrderCount} OP por moneda/cotización` : ''}
        </Typography>
      </Box>
      {hasMultipleProviders && (
        <CustomButton variant="outlined" onClick={() => setActiveSection('batch')} sx={{ height: 40 }}>
          Lote por proveedor
        </CustomButton>
      )}
      {hasMultipleProviders && (
        <CustomButton
          variant="base"
          onClick={markReadyAndMoveNext}
          disabled={!activeProvider.invoices.some((invoice) => includedInvoices[invoice.uuid])}
          sx={{ height: 40 }}
        >
          Listo y siguiente
        </CustomButton>
      )}
    </Box>
  );
};

export default PaymentOrderProviderHeader;
